import React from 'react';
import { PropTypes } from 'prop-types';
import { Button, Table } from '@ipc/ipc-components';

import { AppContentInner, AppContentTitle } from '../../styles';
import { ButtonsWrapper } from './styles';

import { useMasterDataResult } from './hooks';
import {
  TABLE_COLUMNS,
} from './constants';
import LinkToWrapper from '../../utils/linkToWrapper';

const MasterDataResult = ({ match: { params: { id = '' } } }) => {
  const [data, loading] = useMasterDataResult(id);

  return (
    <AppContentInner>
      <AppContentTitle>Receptacle Data Result</AppContentTitle>

      <Table
        columns={TABLE_COLUMNS}
        data={data}
        loading={loading}
        minRows={0}
      />
      <ButtonsWrapper>
        <LinkToWrapper to="/master-data">
          <Button className="CancelButton">Back</Button>
        </LinkToWrapper>
      </ButtonsWrapper>
    </AppContentInner>
  );
};


MasterDataResult.propTypes = {
  match: PropTypes.shape(),
};

export default MasterDataResult;
